<template>
  <Page>
    <BSearch
      :search-list="searchList"
      @on-search="searchHandler"
    >
    </BSearch>
    <BTable
      style="margin-top: 20px;"
      ref="table"
      size="default"
      rowKey="msgId"
      :columns="columns"
      :data="loadData"
    >
    </BTable>
  </Page>
</template>

<script>
// import moment from 'moment'

export default {
  name: 'Message',
  data () {
    return {
      queryParam: {},
      loadData: parameter => {
        return this.$http.action.smsRecordQueryPage(Object.assign(parameter, this.queryParam)).then(response => {
          const { data } = response
          return data
        })
      },
      searchList: [
        {
          label: '手机号',
          key: 'phoneNo',
          type: 'input'
        }, {
          label: '状态',
          key: 'status',
          type: 'select',
          // options: this.$u.getSelectOptionsByDataMap('msgStatus', this.dataMap)
          options: [
            {
              id: '01',
              value: '发送中'
            },
            {
              id: '02',
              value: '发送成功'
            },
            {
              id: '03',
              value: '发送失败'
            }
          ]
        }
        // {
        //   label: '完成日期',
        //   key: 'time',
        //   type: 'rangePicker'
        // }
      ],
      columns: [
        {
          title: '序号',
          fixed: 'left',
          width: 100,
          customRender: (text, record, index) => index + 1
        },
        {
          title: '手机号',
          dataIndex: 'phoneNo'
        },
        {
          title: '渠道',
          dataIndex: 'channelDesc'
        },
        {
          title: '状态',
          dataIndex: 'status',
          customRender: (text, record, index) => {
            return this.$u.changeStatus(text, record, index)
          }
        },
        {
          title: '短信内容',
          dataIndex: 'content',
          ellipsis: true
        },
        {
          title: '渠道发送参数',
          dataIndex: 'reqData',
          ellipsis: true
        },
        {
          title: '渠道应答数据',
          dataIndex: 'resData',
          ellipsis: true
        },
        {
          title: '完成时间',
          dataIndex: 'updateTime'
        }
      ]
    }
  },
  methods: {
    searchHandler (values) {
      this.queryParam = values
      this.$refs.table.refresh(true)
    }
  }
}
</script>

<style scoped lang="less">
</style>
